<template>
  <GridPage
    title="Order Statuses"
    subtitle=""
    viewset="/shop/admin/order-status/"
    :actions="actions"
    :fields="fields"
    :showAddButton="true"
    :refresh="refresh"
    @addButton="handleAddButton"
    @rowAction="handleRowAction"
  >
    <template v-slot:filters>
      {{ editOrderStatus }}
    </template>
    <template v-slot:modals>
      <EditModal
        :editOrderStatus="editOrderStatus"
        @close="handleCloseEditModal"
        @dataUpdated="handleDataUpdated"
      />
      <DeleteModal
        :orderStatusKey="deletePK"
        @close="handleCloseDeleteModal"
        @dataUpdated="handleDataUpdated"
      />
      <AddModal
        :show-modal="showAddModal"
        @close="handleCloseAddModal"
        @dataUpdated="handleDataUpdated"
      />
    </template>
  </GridPage>
</template>

<script>
import GridPage from "@/components/layout/Page/GridPage.vue";
import formatters from "@/components/DataGrid/formatters";

import EditModal from "./EditModal";
import AddModal from "./AddModal";
import DeleteModal from "./DeleteModal";

export default {
  data() {
    return {
      showAddModal: false,
      editOrderStatus: null,
      deletePK: null,
      publishedFilterOptions: [
        { name: "", title: "Show All" },
        { name: "1", title: "Published Only" },
        { name: "0", title: "Unpublished Only" }
      ],
      publishedFilter: "",
      refresh: 0,
      actions: [
        {
          name: "Edit",
          icon: "edit",
          event: "edit"
        },
        {
          name: "Delete",
          icon: "close",
          theme: "danger",
          event: "delete",
          condition(rowData) {
            return !rowData.system_default;
          }
        }
      ],
      fields: [
        {
          name: "key",
          title: "Key",
          sortField: "key",
          visible: false
        },
        {
          name: "num_orders",
          title: "Num Orders",
          visible: true
        },
        {
          name: "internal_label",
          title: "Internal Label",
          visible: true
        },
        {
          name: "customer_label",
          title: "Customer Label",
          visible: true
        },

        {
          name: "stage",
          title: "Stage",
          visible: true
        },
        {
          name: "system_default",
          title: "System Default",
          visible: true
        },
        {
          name: "finalized_only",
          title: "Require Finalized",
          visible: true
        }
      ]
    };
  },
  computed: {},
  methods: {
    handleRowAction(data) {
      if (data.action.event === "edit") {
        this.editOrderStatus = data.props.rowData;
      }
      if (data.action.event === "delete") {
        this.deletePK = data.props.rowData.key;
      }
    },
    handleCloseEditModal(event) {
      this.editOrderStatus = null;
    },
    handleAddButton(event) {
      this.showAddModal = true;
    },
    handleCloseAddModal(event) {
      this.showAddModal = false;
    },
    handleCloseDeleteModal(event) {
      this.deletePK = null;
    },
    handleDataUpdated(event) {
      this.refresh = this.refresh + 1;
    }
  },
  components: {
    GridPage,
    EditModal,
    AddModal,
    DeleteModal
  },
  beforeCreate() {
    // this.$store.dispatch("productCategories/init");
  }
};
</script>

<style></style>
